export enum TransitionDuration {
  Fast = '200ms',
  Medium = '400ms',
}
